import axios from 'axios'
import { defineStore } from 'pinia'

import { ref } from 'vue'

export const useGeoStore = defineStore('geoStore', function () {
  const geoData = ref(null)
  const geoLoading = ref(true)

  async function getGeoData() {
    try {
      const response = await axios.get('https://ipapi.co/json/')
      geoData.value = response.data
    } catch (e) {
      console.error('[useGeoStore]', e)
    } finally {
      geoLoading.value = false
    }
  }

  return { getGeoData, geoData, geoLoading }
})
